module.exports = __webpack_public_path__ + "img/Icons---General---Shield-protected.b689a772.svg";